import { ServiceClient } from 'src/utils'
import { MailTemplateRow, SmtpConfig } from './scopes'

const serviceClient = ServiceClient.singleton()

export class MailConfigService {
    static #INSTANCE = new MailConfigService()
    static readonly singleton = () => MailConfigService.#INSTANCE

    async fetchConfig(): Promise<SmtpConfig> {
        const data = await serviceClient.authGet<SmtpConfig>(
            '/api/mail/config'
        )
        return data
    }

    async saveConfig(config: SmtpConfig): Promise<SmtpConfig> {
        const data = await serviceClient.authPost<SmtpConfig>('/api/mail/config', config)
        return data
    }

    async fetchTemplates(nameFilter?: string): Promise<MailTemplateRow[]> {
        const data = await serviceClient.authGet<MailTemplateRow[]>(
            `/api/mail/templates${nameFilter ? `?filter=${nameFilter}` : ''}`
        )
        return data
    }

    async fetchTemplateById(templateId: number): Promise<MailTemplateRow> {
        const data = await serviceClient.authGet<MailTemplateRow>(`/api/mail/templates/${templateId}`)
        return data
    }

    async createTemplate(template: MailTemplateRow): Promise<MailTemplateRow> {
        const data = await serviceClient.authPost<MailTemplateRow>('/api/mail/templates', template)
        return data
    }

    async updateTemplate(templateId: number, template: MailTemplateRow): Promise<MailTemplateRow> {
        const data = await serviceClient.authPut<MailTemplateRow>(`/api/mail/templates/${templateId}`, template)
        return data
    }

    async deleteTemplate(templateId: number): Promise<void> {
        await serviceClient.authDelete(`/api/mail/templates/${templateId}`)
    }
}

export default MailConfigService.singleton()
